import { apiClient } from './apiClient.js';
import type {
  ApiResponse,
  AuthUser,
  UpdateSchedulingLinkRequest,
} from '@onboarding-dashboard/shared';

export const userService = {
  async getProfile(): Promise<ApiResponse<AuthUser>> {
    return apiClient.get<AuthUser>('/users/profile');
  },

  async updateSchedulingLink(data: UpdateSchedulingLinkRequest): Promise<ApiResponse<AuthUser>> {
    return apiClient.patch<AuthUser>('/users/profile/scheduling-link', data);
  },

  async removeSchedulingLink(): Promise<ApiResponse<AuthUser>> {
    return apiClient.delete<AuthUser>('/users/profile/scheduling-link');
  },
};
